import { Injectable } from '@angular/core';
import { SliceType, MinMax } from './viewer-settings.store';

type ModelSettingRecordType = {
  [slice in 'inlineMixMax' | 'crosslineMinMax' | 'depthMinMax']?: MinMax;
} & {
  auto?: boolean;
  cmap?: string;
  vpRef?: number;
};
type JobModelSettingsType = {
  [modelType: string]: ModelSettingRecordType
}&{
  activeModel?: string
}
type ModelSettingsType = {
  [jobId: string]: JobModelSettingsType 
}

@Injectable({
  providedIn: 'root',
})
export class ModelViewerSettingsService {
  private readonly MODEL_STORAGE_KEY = "modelViewerSettings";
  private readonly MAX_ENTRIES = 20;

  public savedModelSettings : ModelSettingsType = {}

  saveModelSettings(jobId: string, currentModel: string, slice: SliceType, settings : any){
    // this will save model settings i.e. the min and max values of the models and the specific properties

    // check if exists, and creates if doesn't
    this.savedModelSettings[jobId] ??= {};
    // heirarchy: job ID > currentModel > settings
    this.savedModelSettings[jobId][currentModel] ??= {}

    // selectedCmap: string,

    if (slice == 'inline' ){
      this.savedModelSettings[jobId][currentModel].inlineMixMax = settings.minMax
    }
    else if (slice == 'crossline' ){
      this.savedModelSettings[jobId][currentModel].crosslineMinMax = settings.minMax
    }
    else {
      this.savedModelSettings[jobId][currentModel].depthMinMax = settings.minMax
    }

    // depending on the currentModel, also save the vpRef
    if (currentModel == 'Total_Vp_Update') this.savedModelSettings[jobId][currentModel].vpRef = settings?.vpRef || 0
    
    this.savedModelSettings[jobId][currentModel].auto = settings.auto
    this.savedModelSettings[jobId][currentModel].cmap = settings.cmap
    this.savedModelSettings[jobId].activeModel = currentModel

    // console.log('saving', currentModel, this.savedModelSettings[jobId][currentModel.id])
    
    localStorage.setItem(this.MODEL_STORAGE_KEY, JSON.stringify(this.savedModelSettings));
  }


  loadModelSettings() {
    const rawData = localStorage.getItem(this.MODEL_STORAGE_KEY)
    const data = rawData ? JSON.parse(rawData) : {}

    this.savedModelSettings = data
  }

  constructor(){
    this.loadModelSettings();
  }
}
